import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import classes from './ChatBox.module.css'
import { Chats } from './Chats/Chats';
import chatIcon from '../../assets/chat-icon.svg'

export const ChatBox = () => {
    const [toggleChat, setToggleChat] = useState(false);
    const [messageCount, setMessageCount] = useState(0);
    // While a cached preview is showing and the fresh document loads in the
    // background the whole UI is read-only, so the chat must be locked too.
    const isUiLocked = useSelector((state) => state.editor.isUiLocked);

    // Force the panel closed if the UI becomes locked while it's open.
    useEffect(() => {
      if (isUiLocked) setToggleChat(false);
    }, [isUiLocked]);

    const handleToggleChat = () => {
        if (isUiLocked) return;
        setToggleChat(!toggleChat);
        if (toggleChat) {
          // * Reset message count when opening the chat
          setMessageCount(0);
        }
      };
      const incMessageCounter=()=>{
        setMessageCount(messageCount+1)
      }

    return (
        <>
            <div className={classes['chat-box-container']} style={{ visibility: toggleChat ? "visible" : "hidden" }} >
                <div className={classes['chat-togglebar']} onClick={handleToggleChat}>
                    Chat
                </div>
                <Chats onNewMessage={incMessageCounter}/>
                {/* {toggleChat && <Chats />} */}
            </div>
            {!toggleChat &&
                <div
                    className={classes['chat-toggle-icon-container']}
                    onClick={handleToggleChat}
                    style={isUiLocked ? { pointerEvents: 'none', opacity: 0.5 } : undefined}
                >
                <img
                    className={classes['chat-toggle-icon']}
                    src={chatIcon}
                    width={40}
                />
                    {messageCount > 0 && !toggleChat && <div className={classes['message-counter']}>{messageCount}</div>}
                </div>
                }
        </>
    )
}
